import { QuestionRangeSelect } from './QuestionRangeSelect';
export default QuestionRangeSelect;
